import { render, staticRenderFns } from "./HistorialPaymentTable.vue?vue&type=template&id=36b918fd&scoped=true"
import script from "./HistorialPaymentTable.vue?vue&type=script&lang=js"
export * from "./HistorialPaymentTable.vue?vue&type=script&lang=js"
import style0 from "./HistorialPaymentTable.vue?vue&type=style&index=0&id=36b918fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b918fd",
  null
  
)

export default component.exports